import React, { Component } from 'react'
import Img from "gatsby-image"

export default class Musician extends Component {
  render() {
    const { node } = this.props

    return (
      <div className="musician">
        <div className="musician__country font-sans uppercase leading-tight">
          {node.frontmatter.country}
        </div>
        <div className="musician__title text-center mt-4 mb-4 text-sm">
          {node.frontmatter.title}
        </div>
        <div
          className="musician__image mb-4"
        >
          {node.frontmatter.image && (
            <Img
              className="mx-auto"
              fluid={
                node.frontmatter.image.childImageSharp.fluid
              }
            />
          )}
        </div>
        <div
          className="musician__content text-left text-sm mb-4"
          dangerouslySetInnerHTML={{ __html: node.html }}
        />
        {node.frontmatter.link && (
          <div className="musician__link text-xs">
            <a
              href={node.frontmatter.link}
              target="_blank"
              rel="noopener noreferrer"
              className=""
            >
              {node.frontmatter.link}
            </a>
          </div>
        )}
      </div>
    )
  }
}
